import { Row, Col } from "react-bootstrap";
// import whychooseus from "../../assets/image/whychooseus.png";
// import whychooseusmob from "../../assets/image/whychooseusmob.png";
// import quality from "../../assets/quality.svg";
// import approach from "../../assets/approach.svg";
// import team from "../../assets/team.svg";
// import excellence from "../../assets/excellence.svg";
import AOS from "aos";
import "aos/dist/aos.css";
import "./chooseus.css";
import { useEffect } from "react";
const ChooseUs = () => {
  useEffect(() => {
    AOS.init({
      disable: function () {
        return window.innerWidth < 900; // Disable AOS for screens smaller than 900px
      }
    });
    
  }, []);
  return (
    <>
      <Row className="chooseus">
        <Col sm={12} md={12} lg={6} xl={6} className="chooseus1" data-aos="fade-right" data-aos-duration="1000">
          <Row className="chooseus21mobile">
            <span className="chooseus211">WHY CHOOSE US?</span>
            <span className="chooseus212">Experience exceptional quality, reliability, and unmatched service!</span>
            <span className="chooseus213">
              Discover what sets us apart! From top-notch services to customer satisfaction, we ensure a seamless and
              rewarding experience tailored just for you.
            </span>
          </Row>
          {/* <img src={whychooseus} alt="whychooseus" className="chooseusimage1" />
          <img src={whychooseusmob} alt="whychooseusmob" className="chooseusimage1mobile" /> */}
        </Col>

        <Col sm={12} md={12} lg={6} xl={6} className="chooseus2" data-aos="fade-left" data-aos-duration="1000">
          <Row className="chooseus21">
            <span className="chooseus211">WHY CHOOSE US?</span>
            <span className="chooseus212">Experience exceptional quality, reliability, and unmatched service!</span>
            <span className="chooseus213">
              Discover what sets us apart! From top-notch services to customer satisfaction, we ensure a seamless and
              rewarding experience tailored just for you.
            </span>
          </Row>
          <Row className="chooseus3">
            <Col xs={6} sm={6} md={6} lg={6} className="chooseus31">
              <div>
                {/* <img src={quality} alt="quality" /> */}
              </div>
              <span className="chooseus311">Unmatched Quality</span>
              <span className="chooseus312">
                We deliver only the best, ensuring top-tier standards in every service.
              </span>
            </Col>
            <Col xs={6} sm={6} md={6} lg={6} className="chooseus31">
              <div>
                {/* <img src={approach} alt="approach" /> */}
              </div>
              <span className="chooseus311">Customer Approach</span>
              <span className="chooseus312">
                Your satisfaction is our priority, with personalized solutions for every need.
              </span>
            </Col>
            <Col xs={6} sm={6} md={6} lg={6} className="chooseus31">
              <div>
                {/* <img src={team} alt="team" /> */}
              </div>
              <span className="chooseus311">Expert Team</span>
              <span className="chooseus312">
                Our skilled professionals bring expertise and dedication to every project.
              </span>
            </Col>
            <Col xs={6} sm={6} md={6} lg={6} className="chooseus31">
              <div>
                {/* <img src={excellence} alt="excellence" /> */}
              </div>
              <span className="chooseus311">Affordable Excellence</span>
              <span className="chooseus312">Enjoy premium services at prices that fit your budget.</span>
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
};

export default ChooseUs;
